function t(){return-this.snapGrid[0]}export{t as default};
//# sourceMappingURL=minTranslate.js.map
